import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class BridgeService {
    public activateEmail = false;
    public platformUserId: string = null;
    public isProd = environment.deploymentEnvironment === 'production';
}
